module.exports = __webpack_public_path__ + "img/icon-star.50c24909.svg";